import React from 'react'

type ConditionalRenderProps = {
	condition: any
	fallback?: React.ReactNode
	children: React.ReactNode
}

const ConditionalRender: React.FC<ConditionalRenderProps> = ({
	condition,
	fallback = null,
	children
}) => <>{condition ? children : fallback}</>

export default ConditionalRender
